import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { messageFromApiBody } from '@core/utils/api-error-message';

function withNormalizedMessage(error: HttpErrorResponse): HttpErrorResponse {
  if (typeof error.error !== 'object' || error.error === null) {
    return error;
  }
  const body = error.error as { message?: string };
  if (typeof body.message === 'string' && body.message) {
    return error;
  }
  const message = messageFromApiBody(error.error as object);
  if (!message) {
    return error;
  }
  return new HttpErrorResponse({
    error: { ...(error.error as object), message },
    headers: error.headers,
    status: error.status,
    statusText: error.statusText,
    url: error.url ?? undefined,
  });
}

/**
 * Ensures every failed gateway response carries a ready-to-display `error.message`
 * (derived from `uimessage`/`iomessage`), so components whose `handleError` only reads
 * `error.error?.message` show the correct backend text instead of the generic HTTP
 * failure message. Safe no-op when the body isn't the standard gateway envelope.
 */
export const apiErrorMessageInterceptor: HttpInterceptorFn = (req, next) =>
  next(req).pipe(catchError((error: HttpErrorResponse) => throwError(() => withNormalizedMessage(error))));
